import Form from "./Form";

class IndividualForm extends Form {
  constructor(form) {
    super(form);
    this.type = "individual";
  }

  getData() {
    const data = new FormData();
    const f = this.form;

    data.set("post_id", this.post_id);
    data.set("first_name", f.first_name.value);
    data.set("last_name", f.last_name.value);
    data.set("email", f.email.value);
    data.set("phone", f.phone.value);
    data.set("company", f.company.value);
    data.set("function", f.function.value);
    data.set("arrival_date", f.arrival_date.value);
    data.set("departure_date", f.departure_date.value);

    Array.from(f["extras[]"])
      .filter((item) => item.checked)
      .forEach((item) => {
        data.append("extras[]", item.value);
      });

    data.set("room_type", f.room_type.value);
    data.set("payment_method", f.payment_method.value);
    data.set("not_serbian", f.not_serbian.checked ? 1 : 0);
    data.set("message", f.message.value);
    data.set("disclaimer", f.disclaimer.checked ? 1 : 0);

    return data;
  }
}

export default IndividualForm;
